
import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils';
import { getRequest, postRequest } from '../../config/AxiosConfig';

const apiBaseUrl = API_URLS.ADMIN;

const getAuthHeaders = () => {
  const token = getToken();
  // console.log('Token:', token); // Log the token to ensure it's retrieved correctly
  return token ? { Authorization: `Bearer ${token}` } : {};
};


// Add Package Data 
export const AddPackageService = async ({ name }) => {
  try {
    const payload = { "name": name };
    const headers = getAuthHeaders();
    // console.log('Request headers:', headers); // Log headers to check for Authorization

    const response = await postRequest({
      url: apiBaseUrl + "package/create",
      headers: headers,
      data: payload,
    });

    //   console.log(response);
    return response;
  } catch (error) {
    console.error('Error adding Package data:', error.response?.data || error.message);
    throw error;
  }
};


// Retrive Package Data from API
export const retrivePackageService = async () => {
  try {
    const headers = getAuthHeaders();

    const response = await postRequest({
      url: apiBaseUrl + "package/report",
      headers: headers
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching Package data:', error.response?.data || error.message);
    throw error;
  }
};
export const retrivePackageServiceByTotal = async ({ total }) => {
  try {
    const headers = getAuthHeaders();
    const payload = {
      "total_data": total
    }
    const response = await postRequest({
      url: apiBaseUrl + "package/report",
      headers: headers,
      data: payload
    });

    return response;
  } catch (error) {
    console.error('Error fetching Package data:', error.response?.data || error.message);
    throw error;
  }
};


export const retrivePackageByServiceIdService = async ({ serviceId }) => {
  try {
    const headers = getAuthHeaders();
    const payload = {
      'service_id': serviceId,
    }
    const response = await postRequest({
      url: apiBaseUrl + "service-packgae/fetch-package",
      headers: headers,
      data: payload
    });
    return response;
  } catch (error) {
    console.error('Error fetching Package data:', error.response?.data || error.message);
    throw error;
  }
};



export const retriveServiceCharge = async ({ serviceId ,packageId}) => {
  try {
    const headers = getAuthHeaders();
    const payload = {
      'service_id': serviceId,
      'package_id':packageId
    }
    const response = await postRequest({
      url: apiBaseUrl + "service-packgae/fetch",
      headers: headers,
      data: payload
    });
    return response;
  } catch (error) {
    console.error('Error fetching Service Charge data:', error.response?.data || error.message);
    throw error;
  }
};


export const getAssignedDetailsByID = async ({ userId }) => {
  try {
    const headers = getAuthHeaders();

    const payload = {
      user_id: userId,
      total_data: 150 
    };

    const response = postRequest({
      url: apiBaseUrl + "service-details/userid",
      headers: headers,
      data: payload
    });

    return response;

  } catch (error) {
    return error;
  }
};





// Fetch All service
export const FetchAllServices = async ({ search,userId,mobileNumber,email }) => {
    try {
          const headers = getAuthHeaders();
        const payload = {
          "search" : search,
            "user_id": userId,
            "mobile_number": mobileNumber,
            "email": email,
        }
        const response = postRequest({
            url: apiBaseUrl + "fetch-services-with-package",
            headers: headers,
            data: payload
        })
        return response
    } catch (error) {
        return error
    }
}



//  Fetch All By Search
export const FetchSearchServices = async ({ search, page = 1 }) => {
  try {
    const headers = getAuthHeaders();
    const response = await getRequest({
      url: `${apiBaseUrl}user/master-search?search=${encodeURIComponent(search)}&page=${page}`,
      headers,
    });
    return response;
  } catch (error) {
    return error;
  }
};



// Bulk Assign
export const bulkAssignServices = async ({ userId, selectedServices }) => {
  try {
   // console.log("Assigning services to user ID:", selectedServices);
    const headers = getAuthHeaders();

    const payload = {
      user_id: userId,
      services: selectedServices.map((service) => {

        const obj = {
          service_id: service.service_id || service.id,
          package_id: Number(service.package_id),
          service_status: service.service_status || "inactive",
          scope: service.scope || '',
          environment: service.environment || "UAT",
          domain: service.domain || "https://api.com",
          request_count: Number(service.request_count) || 100,
          remarks: service.remarks || ''
        };

        //  FUND TRANSFER (IDFC)
        if (service.end_point?.includes("/idfc/fund-transfer")) {
          obj.pay_account_status = service.status?.value || "";
          obj.daily_limit = service.daily_limit || "";
          obj.monthly_limit = service.monthly_limit || "";
        }

        //  W-EMANDATE (Detect using endpoint)
        if (service.end_point?.includes("/w-emandate")) {
          const em = service || {};

          obj.login_id = em.login_id || "";
          obj.password = em.password || "";
          obj.merchant_code = em.merchant_code || "";
          obj.scheme_code = em.scheme_code || "";
          obj.encryption_key = em.encryption_key || "";
          obj.encryption_iv = em.encryption_iv || "";
          obj.salt = em.salt || "";
          obj.status = em.status || "inactive";
        }

        return obj;
      }),
    };

    return await postRequest({
      url: apiBaseUrl + "bulk-service/assign",
      headers,
      data: payload,
    });

  } catch (error) {
    console.error("❌ Error assigning services:", error);
    throw error;
  }
};





export const editPackageService = async ({ name, package_id }) => {
  try {
    const headers = getAuthHeaders();

    const payload = { name, package_id }; // Ensure package_id is included
    const response = await postRequest({
      url: apiBaseUrl + "package/edit",
      headers: headers,
      data: payload,
    });
    return response;
  } catch (error) {
    console.error('Error editing package data:', error.response?.data || error.message);
    throw error;
  }
};










// Update Package Service
export const updatePackageService = async ({ name, package_id }) => {
  try {
    const headers = getAuthHeaders();
    const payload = { name, package_id };
    const response = await postRequest({
      url: apiBaseUrl + "package/update",
      headers: headers,
      data: payload,
    });
    // console.log('Update response:', response);
    return response;
  } catch (error) {
    console.error('Error updating package data:', error.response?.data || error.message);
    throw error;
  }
};



// Fetch Operator
export const fetchOperatorService = async ({ category = "Prepaid" }) => {
  try {
    const headers = getAuthHeaders();
    const payload = { category }; 
    const response = await postRequest({
      url: apiBaseUrl + "fetch-operator",
      headers,
      data: payload,
    });
    return response;
  } catch (error) {
    console.error("Error fetching operator list:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAllPackagesCharges = async ({ service_id }) => {
  try {
    const headers = getAuthHeaders();
    const payload = { service_id  };
    const response = await postRequest({
      url: apiBaseUrl + "service-packgae/fetch-package",
      headers,
      data: payload,
    });
    return response;
    
  } catch (error) {
    console.error("Error fetching operator list:", error.response?.data || error.message);
    throw error;
  }
};

export const getUsersByServiceId = async ({ service_id, page }) => {
  try {
    const headers = getAuthHeaders();
    const payload = { service_id , page, total_data :200 };
    const response = await postRequest({
      url: apiBaseUrl + "service-user/details",
      headers,
      data: payload,
    });
    return response;
    
  } catch (error) {
    console.error("Error fetching User list:", error.response?.data || error.message);
    throw error;
  }
};
